import { AppConfigKey_FE } from '@nu-art/thunderstorm-frontend/index';
import { ConfigKey_SmartDocs_NoteIds } from '@app/advisor-content-shared';
export const ConfigKeyFE_SmartDocs_NoteIds = new AppConfigKey_FE(ConfigKey_SmartDocs_NoteIds);
//# sourceMappingURL=app-config.js.map